import { Moment } from 'moment';
import { BenchmarkCurveIdentifier } from './user-preferences.types';

export interface BenchmarkCurvePoint {
  year: number;
  month: number;
  yield: number;
}

export enum BenchmarkProvider {
  mmd = 'MMD',
  mac = 'MAC',
  ice = 'ICE AAA'
}

export enum MMDRatingType {
  tripleA = 'Current',
  preRefunded = 'Pre-Re',
  tripleAInsured = 'AAA Insured',
  doubleA = 'AA',
  singleA = 'A',
  bDoubleA = 'BAA',
  interpolated = 'Interpolated'
}

export enum MACRatingType {
  tripleA = 'Current',
  doubleAPlus = 'AA+',
  doubleA = 'AA',
  doubleAMinus = 'AA-',
  singleAPlus = 'A+',
  singleA = 'A',
  singleAMinus = 'A-',
  tripleBPlus = 'BBB+',
  tripleB = 'BBB',
  tripleBMinus = 'BBB-',
  doubleBPlus = 'BB+',
  doubleB = 'BB',
  doubleBMinus = 'BB-',
  singleBPlus = 'B+',
  singleB = 'B',
  singleBMinus = 'B-',
  tripleC = 'CCC',
  singleC = 'C',
  escrowed = 'Escrowed',
  preRefunded = 'Pre- refunded',
  interpolated = 'Interpolated'
}

export enum IceRatingType {
  tripleA = 'ICE AAA'
}

export interface BenchmarkCurve {
  date: Moment;

  data: BenchmarkCurvePoint[];
  identifier: BenchmarkCurveIdentifier;
}

export interface MappedBenchmarkCurve extends BenchmarkCurve {
  provider: BenchmarkProvider;
  shortName: string;
  typeId?: number;
}
